import React from 'react';

export default function UserMessage({ message, isDarkMode }) {
  return (
    <div className="flex justify-end">
      <div
        className={`max-w-[75%] text-right italic px-3 py-2 border-r-2 ${
          isDarkMode
            ? 'text-gray-400 border-gray-600 bg-gray-900/30'
            : 'text-gray-500 border-gray-300 bg-gray-50'
        }`}
      >
        <div className="text-sm leading-relaxed whitespace-pre-wrap">
          {message.content}
        </div>
      </div>
    </div>
  );
}
